import React, {useContext} from 'react';
import {ConfirmationDialogContext} from "./ConfirmationDialogProvider";

export default function useConfirmationDialog() {
    return useContext(ConfirmationDialogContext);
}